import CustomFileInput from "../../../common/CustomFileInput";
import * as GE from "../GroupEvent.styles";

const TypeTwo = (props) => {
  const {
    inputData,
    setInputData,
    handleInputData,
    detailData,
    cancelInsert,
    typeTwoUseForm,
  } = props;

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    getValues,
    watch,
  } = typeTwoUseForm;

  return (
    <>
      {detailData?.info?.id ? (
        <GE.InfoWrapper>
          <h5 className="mb-10">신청 정보</h5>
          {detailData?.type === "TYPE2" && (
            <>
              <GE.InfoRow>
                <span>회사명</span>
                <span>{detailData?.info?.company}</span>
              </GE.InfoRow>
              <GE.InfoRow>
                <span>신청자명</span>
                <span>{detailData?.info?.name}</span>
              </GE.InfoRow>
              <GE.InfoRow>
                <span>연락처</span>
                <span>{detailData?.info?.phone}</span>
              </GE.InfoRow>
              <GE.InfoRow>
                <span>교육 참석 인원</span>
                <span>{detailData?.info?.cnt}명</span>
              </GE.InfoRow>
              {detailData?.info?.stats === "N" && (
                <GE.InfoRow>
                  <button
                    type="button"
                    className="btn w-100"
                    onClick={() => cancelInsert(detailData?.info?.id)}
                  >
                    신청 취소
                  </button>
                </GE.InfoRow>
              )}
            </>
          )}
        </GE.InfoWrapper>
      ) : (
        <>
          <div className="form-group">
            <div className="mb-3">
              <label htmlFor="company" className="form-label">
                <h6>회사명</h6>
              </label>
              <input
                id="company"
                className={`form-input ${errors?.company && "border-danger"}`}
                type="text"
                value={inputData?.company || ""}
                {...register("company", {
                  onChange: (e) => handleInputData(e, "company"),
                })}
              />
              {errors?.company && (
                <div className="text-danger mt-1">
                  {errors.company?.message}
                </div>
              )}
            </div>
            <div className="mb-3">
              <label htmlFor="name" className="form-label">
                <h6>신청자명</h6>
              </label>
              <input
                id="name"
                className={`form-input ${errors?.name && "border-danger"}`}
                type="text"
                value={inputData?.name || ""}
                {...register("name", {
                  onChange: (e) => handleInputData(e, "name"),
                })}
              />
              {errors?.name && (
                <div className="text-danger mt-1">{errors.name?.message}</div>
              )}
            </div>
            <div className="mb-3">
              <label htmlFor="phone" className="form-label">
                <h6>연락처</h6>
              </label>
              <input
                id="phone"
                className={`form-input ${errors?.phone && "border-danger"}`}
                type="text"
                value={inputData?.phone || ""}
                {...register("phone", {
                  onChange: (e) => handleInputData(e, "phone"),
                })}
              />
              {errors?.phone && (
                <div className="text-danger mt-1">{errors.phone?.message}</div>
              )}
            </div>
            <div className="mb-3">
              <label htmlFor="cnt" className="form-label">
                <h6>교육 참석 인원</h6>
              </label>
              <input
                id="cnt"
                className={`form-input ${errors?.phone && "border-danger"}`}
                type="number"
                min="1"
                value={inputData?.cnt || ""}
                {...register("cnt", {
                  onChange: (e) => handleInputData(e, "cnt"),
                })}
              />
              {errors?.cnt && (
                <div className="text-danger mt-1">{errors.cnt?.message}</div>
              )}
            </div>
            <div className="d-fles flex-column mb-3">
              <div className="custome-checkbox d-flex align-items-start">
                <input
                  type="checkbox"
                  id="checkBox0"
                  className="form-check-input"
                  style={{ paddingTop: "2px" }}
                  checked={inputData?.check || ""}
                  {...register("check", {
                    onChange: (e) => handleInputData(e, "check"),
                  })}
                />
                <label className="form-check-label" htmlFor="checkBox0"></label>
                <label htmlFor="checkBox0">
                  (동의 필수) 제출하신 정보로 신청자께 칼렛스토어 소식을
                  보내드립니다.
                </label>
              </div>
              {errors?.check && (
                <div className="text-danger mt-1">{errors.check?.message}</div>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};
export default TypeTwo;
